
import { Component } from "vue-property-decorator";
import { RenderItem, RenderType } from "@/app/Types";
import { ComponentTypeDictionaryService } from "@/app/dynamic-components/forms/form-components/form-component.lookup";
import FormWrapper from "@/app/dynamic-components/forms/FormWrapper.vue";
import BaseDynamicCompositeComponent from "@/app/dynamic-components/forms/form-components/form-component-composite.base";
import FormComponentErrorMessage from "@/app/dynamic-components/forms/form-validations/form-component-error-message.vue";
import {ValidationError} from "@/app/dynamic-components/forms/form-validations/form-validator.base";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";

export type DateTimePickerMetaData = {
  label: string;
  defaultValue: string //if u want calculation done on date and time as well, use this defaultvalue instead
  date: {restrictions: string, defaultValue: string}
  time: {restrictions: string, defaultValue: string}
};

@Component({
  components: {DynamicComponentConfigManager, FormComponentErrorMessage, FormWrapper },
  computed: {
    RenderType() {
      return RenderType;
    },
    ComponentTypeDictionaryService() {
      return ComponentTypeDictionaryService;
    },
  },
})
export default class DateTimePickerBase extends BaseDynamicCompositeComponent<DateTimePickerMetaData> {


  public getDefaultValue(): any {
    if(this.entry?.metadata?.defaultValue && this.entry.root){
      let d = this.entry.root?.resolvePlaceholders(this.entry.metadata.defaultValue);
      d = this.entry.root.externalContext.resolveFieldValue(d);
      const x = new Date(d);
      if(isNaN(x.getTime())) return null;
      return x.toISOString();
    }
    return null;
  }

  protected async convertFormDataToValue(formData: any): Promise<any> {
    if (formData === null || formData.date === null || formData.time === null)
      return null;
    const date = new Date(formData.date);
    const t = formData.time.split(":");
    date.setHours(t[0]);
    date.setMinutes(t[1]);
    return date;
  }

  protected async convertValueToFormData(value: any): Promise<any> {
    if (!value) return null;
    if (typeof value !== "string") return null;
    const d0 = new Date(value);
    const d1 = new Date(value);
    d0.setHours(0);
    d0.setMinutes(0);
    return {
      date: d0,
      time: d1.getHours() + ":" + d1.getMinutes(),
    };
  }
  protected createDefinition(): RenderItem | null {
    if (!this.entry) return null;

    const displayMode = this.entry.resolvedDisplayMode();
    return {
      id: "root",
      name: "",
      type: RenderType.LinearSection,
      displayMode: displayMode,
      displayModeRule: this.entry.displayModeRule,
      computedValue: "",
      validators: [],
      metadata: {
        direction: "horizontal",
      },
      children: [
        {
          id: "date",
          name: this.$tc("datetime.date"),
          type: RenderType.DatePicker,
          displayMode: "inherit",
          displayModeRule: "",
          computedValue: "",
          validators: ['ruleError(data.inheritErrors|length[]:{gt:0},)'],
          metadata: this.entry.metadata?.date || {},
        },
        {
          id: "time",
          name: this.$tc("datetime.time"),
          type: RenderType.TimePicker,
          displayMode: "inherit",
          displayModeRule: "",
          computedValue: "",
          validators: ['ruleError(data.inheritErrors|length[]:{gt:0},)'],
          metadata: this.entry.metadata?.time || {},
        },
      ],
    };
  }
}
